<template>
  <div
    class="fixed left-0 top-0 bg-overlay w-full h-full z-65001"
  >
    <div class="bg-white fixed left-1/2 top-1/2 rounded-lg p-4 modal-content flex flex-col">
      <div
        ref="scrollingContainer"
        class="w-full flex-grow overflow-y-auto pb-4 relative flex flex-col"
      >
        <div class="bg-white">
          <p class="font-bold text-red-600 text-center"> Warning! This action can not be reverted!</p>
          <p class="font-bold text-red-600 text-center"> Please save your layout first to not lose the layout for the
            current era.</p>
          <p class="font-medium text-center">When you continue the era of the layout and the level of the town hall will
            be increased.</p>
          <p class="font-medium text-center">In the following you can choose which buildings should level up to the
            highest possible level for the new era.</p>
          <p class="font-medium text-center">The era and level of collectable and event buildings will not be
            changed.</p>
        </div>
        <div
          v-if="loaded"
          class="flex flex-row gap-0 flex-wrap mt-2"
        >

          <LevelUpListItem
            v-for="(building, index) in buildings"
            :key="index"
            :building="building"
            :index="index"
            @activate="toggleBuildingActive"
          />
        </div>
      </div>

      <p class="mt-3 flex flex-row">
        <button
          class="rounded bg-red-600 hover:bg-gray-600 transition duration-300 text-white uppercase text-base py-2 px-8 cursor-pointer"
          @click="closeClicked"
        >
          Cancel
        </button>
        <span class="flex-grow"/>
        <button
          class="rounded bg-gray-roc hover:bg-gray-600 transition duration-300 text-white uppercase text-base py-2 px-8 cursor-pointer"
          @click="levelUpClicked"
        >
          Level Up
        </button>
      </p>
    </div>
  </div>
</template>

<script>
import Eras from "@/roc/era";
import LevelUpListItem from "@/components/Modal/LevelUpListItem.vue";
import Buildings from "@/roc/building";
import {onMounted, ref} from 'vue';
import {useApplicationStore} from '@/roc/stores/ApplicationStore';
import {useLayoutStore} from '@/roc/stores/LayoutStore';

export default {
  components: {
    LevelUpListItem
  },
  emits: ['done', 'close'],
  setup(props, context) {
    const appStore = useApplicationStore();
    const lytStore = useLayoutStore();

    const buildings = ref([]);
    const loaded = ref(false);

    onMounted(() => {
      const buildingArray = [];
      const currentEraIndex = Object.keys(Eras).indexOf(appStore.selectedEra);

      for (let i = 0; i < Buildings.length; ++i) {
        lytStore.mapBuildings((building) => {
          if (building.name === Buildings[i].name) {
            const buildingEraIndex = Object.keys(Eras).indexOf(building.minEra);

            if (currentEraIndex >= buildingEraIndex
              && !building.isEvent
              && !building.isCollectable
              && !building.isCityHall
            ) {
              buildingArray.push({
                id: building.templateId,
                name: building.name,
                type: building.type,
                active: true
              });
            }

            return false;
          }
        });
      }

      buildings.value = [...buildingArray];
      loaded.value = true;
    });

    return {
      buildings,
      loaded,

      closeClicked() {
        context.emit('close');
      },

      levelUpClicked() {
        context.emit('done', buildings.value);
      },

      toggleBuildingActive(index) {
        buildings.value[index].active = !buildings.value[index].active;
      }
    };
  }
};
</script>

<style scoped>
.modal-content {
  width: 900px;
  height: 550px;
  margin-left: -450px;
  margin-top: -275px;
}
</style>
